import { useCallback, useEffect, useState } from "react";

import { AssistitoRepository } from "core/data/index";

import { Presentation, Area, Professionista, DataPreventivo, Assistito, ResultPrenotazione, AreaCAP } from "pages/index";
import { Auth } from "core/interfaces/components/index";
import { IAssistito, IFamiliare, IPersonaRiferimento, IRegisterFamiliareEsistenteRequest } from "core/interfaces/data/IAssistitoRequest";

import { IRegisterRequest } from "core/interfaces/data/IAssistitoRequest";
import "core/extensions/date.extensions";
import { formStep } from "types/StepEnums";
import { PagesEnum } from "types/PagesEnum";
import { resetDataForm, setResoultPrenotazione, setDestinatarioAssistenza } from "core/redux/features/dataForm/dataFormSlice";
import { resetLogin } from "core/redux/features/session/sessionSlice";
import { IResultPrenotazioneDataSlice } from "core/redux/features/dataForm/dataFormSliceInterfaces";
import { getReduxResultPrenotazioneData } from "utils/ReduxUtils";
import useSession from "utils/Session";
import { IPreventivoDetailData } from "core/interfaces/data/IPagamentoRequest";
import NavigationManager from "utils/NavigationManager";
import ModalitaPagamento from "pages/Prenotazione/Form/ModalitaPagamento/ModalitaPagamento";
import { IModalitaPagamentoForm } from "core/interfaces/data/IModalitaPagamentoForm";
import { SelezioneArea } from "types/SelezioneAreaEnum";
import { IFormProps } from "./IFormProps";
import PrestazioneSidebar from "./Prestazione/PrestazioneSidebar/PrestazioneSidebar";
import { Enhanced } from "utils/ReactUtils";
import { StorageHelper } from "utils/SessionStorageHelper";
import { AssistitoEnums } from "types/AssistitoEnums";

const Form: React.FC<IFormProps> = ({ InitSession, resetForm, setResetForm, OnChangePasswordRequest, sessionInfo, dispatch, i18n, t, dataForm }) => {
	const { GoToPage, GoToStep, MoveStep } = NavigationManager(sessionInfo);
	const [createNew, setCreateNew] = useState<boolean>();

	const {  OnFinishSession } = useSession(sessionInfo);
	
	const resetData = useCallback(() => {
		dispatch(resetDataForm());
	}, [dispatch]);

	const onClickBegin =  useCallback(() => {
		resetData();
		InitSession();
	},[InitSession, resetData]);


	useEffect(() => {
		if (resetForm) {
			resetData();
			setResetForm(false);
		}
	}, [resetData, resetForm, setResetForm]);

	const OnSubmitAssistito = useCallback( async (destinatario: IAssistito | IFamiliare, createNew: boolean) => {
		dispatch(setDestinatarioAssistenza(destinatario));
		setCreateNew(createNew);
		GoToStep(formStep.SelectModalitaPagamento);
	},[GoToStep, dispatch]);

	const GoToPayment = useCallback( (res: IResultPrenotazioneDataSlice) => {
		if (window.CONFIG.REACT_APP_PAYMENT.ENABLED && !res.PaymentSuccess) {
			GoToPage(PagesEnum.Payment, formStep.Pagamento, { result: res });
			OnFinishSession(sessionInfo.step as number, true);
		} else {
			OnFinishSession(sessionInfo.step as number, true);
			MoveStep("next");
		}
	},[GoToPage, MoveStep, OnFinishSession, sessionInfo.step]);

	/**
	 * Quando fa la registrazione e crea il familiare legato chiama questo metodo
	 * per creare il riferimento e l'anagrafica
	 */
	const OnSubmitNewRequest =  useCallback(async (formData: IModalitaPagamentoForm) => {
		var assistito = dataForm.destinatarioAssistenza as IAssistito;

		const AttivitaAlle = dataForm.orario?.A!;
		const AttivitaDalle = dataForm.orario?.Da!;

		const riferimento: IPersonaRiferimento = !dataForm.registerData?.PerFamiliare
			? {
					Nome: assistito.Nome!,
					Cognome: assistito.Cognome!,
					Telefono: assistito.TelefonoContatti?.toString() ?? "",
					Sesso: assistito.Sesso! === "M" ? AssistitoEnums.Maschio : AssistitoEnums.Fremminia,
					DataNascita: assistito.DataNascita.toDateWS(),
					CodiceFiscale: assistito.CodiceFiscale!,
					ComuneNascita: assistito.ComuneNascita!.Descrizione!,
					ComuneNascitaISTAT: assistito.ComuneNascita!.CodIstat!,
					Cittadinanza: assistito.IdCittadinanza!,
			  }
			: {
					Nome: dataForm.registerData?.Nome!,
					Cognome: dataForm.registerData?.Cognome!,
					Telefono: dataForm.registerData?.TelefonoContatti!.toString()!,
					Sesso: dataForm.registerData?.Sesso! === "M" ? AssistitoEnums.Maschio : AssistitoEnums.Fremminia,
					DataNascita: dataForm.registerData?.DataNascita!.toDateWS(),
					CodiceFiscale: dataForm.registerData?.CodiceFiscale!,
					ComuneNascita: dataForm.registerData?.ComuneNascita.Descrizione!,
					ComuneNascitaISTAT: dataForm.registerData?.ComuneNascita.CodIstat!,
					Cittadinanza: dataForm.registerData?.Cittadinanza.ID,
			  };

		try {
			const registerProps: IRegisterRequest = {
				Username: sessionInfo.isLogged ? "" : dataForm.registerData?.Email!,
				Password: sessionInfo.isLogged ? "" : dataForm.registerData?.Password!,
				ConsensoSMS: sessionInfo.isLogged ? false : dataForm.registerData?.ConsensoSMS,
				ConsensoMail: sessionInfo.isLogged ? false : dataForm.registerData?.ConsensoMail,
				Anagrafica: {
					Matricola: -1,
					Nome: assistito.Nome!,
					Cognome: assistito.Cognome!,
					CodiceFiscale: assistito.CodiceFiscale!,
					TelefonoDomicilio: assistito.TelefonoDomicilio!,
					CapResidenza: assistito.ComuneResidenza.CAP,
					CapDomicilio: assistito.ComuneDomicilio.CAP,
					DataNascita: assistito.DataNascita.toDateWS(),
					CodiceIstatComuneNascita: assistito.ComuneNascita?.CodIstat!,
					ComuneNascita: assistito.ComuneNascita?.Descrizione!,
					ProvinciaNascita: assistito.ComuneNascita?.Provincia!,
					Sesso: assistito.Sesso!,
					TelefonoContatti: assistito.TelefonoContatti!,

					IndirizzoResidenza: assistito.IndirizzoResidenza!,
					IndirizzoResidenzaDettagli: assistito.IndirizzoResidenzaDettagli!,
					TelefonoResidenza: assistito.TelefonoResidenza!,

					CodiceMunicipioResidenza: assistito.MunicipioResidenza ? assistito.MunicipioResidenza : "",
					ProvinciaResidenza: assistito.ComuneResidenza?.Provincia!,
					ComuneResidenza: assistito.ComuneResidenza.Descrizione!,
					CodiceIstatComuneResidenza: assistito.ComuneResidenza.CodIstat!,

					CodiceIstatComuneDomicilio: assistito.ComuneDomicilio.CodIstat,
					IndirizzoDomicilio: assistito.IndirizzoDomicilio!,
					IndirizzoDomicilioDettagli: assistito.IndirizzoDomicilioDettagli!,
					IntComuneResidenza: assistito.ComuneDomicilio.Descrizione!, // comune di domicilio
					IntProvinciaResidenza: assistito.ComuneDomicilio.Provincia!, // provincia domicilio
					IntMunicipioRoma: assistito.MunicipioDomicilio ? assistito.MunicipioDomicilio : "", //municipio domicilio

					IdCittadinanza: assistito.IdCittadinanza!,
					Privacy: assistito.Privacy,
					Terzi: assistito.Terzi,
					Marketing: assistito.Marketing,

					ComunicazioniMMG: assistito.ComunicazioniMMG,
					ComunicazioniServizio: assistito.ComunicazioniServizio,
					DocSanitari: assistito.DocSanitari,
				},
				PersonaRiferimento: riferimento,
				IdOperatore: dataForm.professionista?.IdOperatore!,
				SessionId: sessionInfo.sessione!.idSessione!,
				Tariffa: dataForm.tariffa?.ImportoTariffa!,
				AttivitaAlle: AttivitaAlle,
				AttivitaDalle: AttivitaDalle,
				IguAttivita: dataForm.prestazione?.IguAttivita!,
				IGULegame: assistito.LegameUtente ? assistito.LegameUtente.toString() : "",
				culture: i18n.language,
				IdSessione: sessionInfo.sessione!.idSessione!,
				step: sessionInfo.step as number,
				IdCausaleIva: dataForm.tariffa?.IdCausaleIva!,
				ImportoTariffaConIva: dataForm.tariffa?.ImportoTariffaConIva!,
				Logged: sessionInfo.isLogged,
				IdEquipe: dataForm.area?.IdEquipe!,
				CodGruppoEquipe: dataForm.area?.CodGruppo!,
				LuogoErogazione: dataForm.area?.LuogoErogazione!,
				ModalitaPagamento: formData.pagamento,
				NoteUtente: formData.note,
			};

			const resPrenotazione = await AssistitoRepository.Register(registerProps);

			let prenotazioneDett: IPreventivoDetailData = {
				IguAttivita: dataForm.prestazione?.IguAttivita!,
				Attivita: dataForm.prestazione?.Attivita!,
				IdOperatore: dataForm.professionista?.IdOperatore!,
				DsOperatore: dataForm.professionista?.DsOperatore!,
				OperatoreGenerico: dataForm.professionista?.Generico!,
				IdCausaleIva: dataForm.tariffa?.IdCausaleIva!,
				CausaleIva: "",
				Da: dataForm.orario?.Da!.toDateWS()!,
				A: dataForm.orario?.A!.toDateWS()!,
				LuogoErogazione: dataForm.area?.LuogoErogazione,
			};

			var res = getReduxResultPrenotazioneData(false, resPrenotazione, [prenotazioneDett], formData.pagamento);

			if (dataForm.tariffa?.ImportoTariffaConIva === 0) res.PaymentSuccess = true;

			dispatch(setResoultPrenotazione(res));
			GoToPayment(res);
		} catch (err: any) {
			dispatch(setResoultPrenotazione({ IsError: true }));
			MoveStep("next");
		}
	},[GoToPayment, MoveStep, dataForm.area?.CodGruppo, dataForm.area?.IdEquipe, dataForm.area?.LuogoErogazione, dataForm.destinatarioAssistenza, dataForm.orario?.A, dataForm.orario?.Da, dataForm.prestazione?.Attivita, dataForm.prestazione?.IguAttivita, dataForm.professionista?.DsOperatore, dataForm.professionista?.Generico, dataForm.professionista?.IdOperatore, dataForm.registerData?.Cittadinanza.ID, dataForm.registerData?.CodiceFiscale, dataForm.registerData?.Cognome, dataForm.registerData?.ComuneNascita.CodIstat, dataForm.registerData?.ComuneNascita.Descrizione, dataForm.registerData?.ConsensoMail, dataForm.registerData?.ConsensoSMS, dataForm.registerData?.DataNascita, dataForm.registerData?.Email, dataForm.registerData?.Nome, dataForm.registerData?.Password, dataForm.registerData?.PerFamiliare, dataForm.registerData?.Sesso, dataForm.registerData?.TelefonoContatti, dataForm.tariffa?.IdCausaleIva, dataForm.tariffa?.ImportoTariffa, dataForm.tariffa?.ImportoTariffaConIva, dispatch, i18n.language, sessionInfo.isLogged, sessionInfo.sessione, sessionInfo.step]);

	/**
	 * Quando si sceglie un familiare dalla lista si chiama questo metodo per chiamare
	 * il servizio giusto
	 *
	*/
	const OnSubmitRequestFamiliareEsistente =  useCallback(async (formData: IModalitaPagamentoForm) => {
		var familiare = dataForm.destinatarioAssistenza as IFamiliare;

		try {
			const AttivitaAlle = dataForm.orario?.A!;
			const AttivitaDalle = dataForm.orario?.Da!;

			const props: IRegisterFamiliareEsistenteRequest = {
				IdOperatore: dataForm.professionista?.IdOperatore!,
				SessionId: sessionInfo.sessione!.idSessione!,
				Tariffa: dataForm.tariffa?.ImportoTariffa!,
				AttivitaAlle: AttivitaAlle,
				AttivitaDalle: AttivitaDalle,
				IguAttivita: dataForm.prestazione?.IguAttivita!,
				culture: i18n.language,
				IdSessione: sessionInfo.sessione!.idSessione!,
				step: sessionInfo.step as number,
				Matricola: parseInt(familiare.Matricola),
				IdCausaleIva: dataForm.tariffa?.IdCausaleIva!,
				IdEquipe: dataForm.area?.IdEquipe!,
				CodGruppoEquipe: dataForm.area?.CodGruppo!,
				LuogoErogazione: dataForm.area?.LuogoErogazione,
				ModalitaPagamento: formData.pagamento,
				NoteUtente: formData.note,
			};

			const resPrenotazione = await AssistitoRepository.RegisterFamiliareEsistente(props);

			let prenotazioneDett: IPreventivoDetailData = {
				IguAttivita: dataForm.prestazione?.IguAttivita!,
				Attivita: dataForm.prestazione?.Attivita!,
				IdOperatore: dataForm.professionista?.IdOperatore!,
				DsOperatore: dataForm.professionista?.DsOperatore!,
				OperatoreGenerico: dataForm.professionista?.Generico!,
				IdCausaleIva: dataForm.tariffa?.IdCausaleIva!,
				CausaleIva: "",
				Da: dataForm.orario?.Da!.toDateWS()!,
				A: dataForm.orario?.A!.toDateWS()!,
				LuogoErogazione: dataForm.area?.LuogoErogazione,
			};

			var res = getReduxResultPrenotazioneData(false, resPrenotazione, [prenotazioneDett], formData.pagamento);
			if (dataForm.tariffa?.ImportoTariffaConIva === 0) res.PaymentSuccess = true;

			dispatch(setResoultPrenotazione(res));
			GoToPayment(res);
		} catch (err: any) {
			dispatch(setResoultPrenotazione({ IsError: true }));
			MoveStep("next");
		}
	},[GoToPayment, MoveStep, dataForm.area?.CodGruppo, dataForm.area?.IdEquipe, dataForm.area?.LuogoErogazione, dataForm.destinatarioAssistenza, dataForm.orario?.A, dataForm.orario?.Da, dataForm.prestazione?.Attivita, dataForm.prestazione?.IguAttivita, dataForm.professionista?.DsOperatore, dataForm.professionista?.Generico, dataForm.professionista?.IdOperatore, dataForm.tariffa?.IdCausaleIva, dataForm.tariffa?.ImportoTariffa, dataForm.tariffa?.ImportoTariffaConIva, dispatch, i18n.language, sessionInfo.sessione, sessionInfo.step]);

	/**
	 * Torno alla pagine di registrazione
	 */
	const BackToRegisterPage = useCallback( () => {
		dispatch(resetLogin());
		GoToStep(formStep.Authentication);
	},[GoToStep, dispatch]);

	const OnChangePassword = useCallback( (changePasswordRequired: boolean, oldPassword?: string) => {
		StorageHelper.setItem("ReservationData", JSON.stringify(dataForm));
		OnChangePasswordRequest(changePasswordRequired, oldPassword);
	},[OnChangePasswordRequest, dataForm]);

	const GetSelezioneAreaComponent =  useCallback(() => {
		if (window.CONFIG.REACT_APP_TIPO_SELEZIONE_AREA === SelezioneArea.AreaCAP) return <AreaCAP />;
		else return <Area />;
	},[]);

	const onModalitaPagamentoSubmit =  useCallback(async (formData: IModalitaPagamentoForm) => {
		if (createNew) {
			await OnSubmitNewRequest(formData);
		} else {
			await OnSubmitRequestFamiliareEsistente(formData);
		}
	},[OnSubmitNewRequest, OnSubmitRequestFamiliareEsistente, createNew]);

	const GetPage = () => {
		switch (sessionInfo.step) {
			case formStep.Home:
				return <Presentation OnClick={onClickBegin} />;
			case formStep.Area:
				return GetSelezioneAreaComponent();
			case formStep.Prestazione:
				return <PrestazioneSidebar />;
			case formStep.Professionista:
				return <Professionista />;
			case formStep.DataPreventivo:
				return <DataPreventivo />;
			case formStep.Authentication:
				return <Auth OnChangePasswordRequest={OnChangePassword} />;
			case formStep.SelectAssistito:
				return <Assistito OnSubmit={OnSubmitAssistito} BackToRegisterPage={BackToRegisterPage} />;
			case formStep.SelectModalitaPagamento:
				return (
					<ModalitaPagamento
						OnSubmit={onModalitaPagamentoSubmit}
						Back={() => {
							GoToStep(formStep.SelectAssistito);
						}}
					/>
				);
			case formStep.ResultPrenotazione:
				return <ResultPrenotazione />;
			default:
				return <div></div>;
		}
	};

	// return (currentPage)
	return GetPage()
};

export default Enhanced(Form, {});
// export default Enhanced(Form, { componentNamespace: "Form" });
